"use client";

import React, { useState, useEffect } from "react";
import { MonitorPlay } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const showcaseItems = [{
  id: "vid-1",
  title: "Official Short Film Trailer",
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602358/img/gameplay_thumb_deviant.png",
  source: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602358/img/gameplay_main_deviant.png",
  duration: "02:15"
}, {
  id: "vid-2",
  title: "Director's Commentary",
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602358/img/gameplay_thumb_base.png",
  source: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602358/img/gameplay_main_base.png",
  duration: "04:30"
}, {
  id: "vid-3",
  title: "The Poseidon Sequence",
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602358/img/gameplay_thumb_pvp.png",
  source: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602358/img/gameplay_main_pvp.png",
  duration: "01:45"
}, {
  id: "vid-4",
  title: "Submarine Set Design",
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602358/img/gameplay_thumb_explore.png",
  source: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602358/img/gameplay_main_explore.png",
  duration: "03:20"
}, {
  id: "vid-5",
  title: "Visual Effects Breakdown",
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602358/img/gameplay_thumb_raid.png",
  source: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602358/img/gameplay_main_raid.png",
  duration: "05:10"
}];
export default function GameplayShowcase() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const activeItem = showcaseItems[activeIndex];
  const handleThumbnailClick = (index: number) => {
    if (index === activeIndex) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setActiveIndex(index);
      setIsTransitioning(false);
    }, 150);
  };
  return <section data-section-id="69910" id="the-screening-room" className="dark bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden relative">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,rgba(0,255,255,0.03)_0%,transparent_70%)]" />
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />

      <div className="max-w-7xl mx-auto relative z-10">
        {}
        <div className="mb-12 flex flex-col items-center md:items-start">
          <div className="flex items-center gap-3 mb-2 text-primary/80">
            <MonitorPlay className="size-5" />
            <span className="text-sm font-mono tracking-widest uppercase">
              Classified Access
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-7xl font-bold uppercase tracking-widest text-foreground drop-shadow-md font-sans">
            The Cinematic Experience
          </h2>
          <div className="h-1 w-32 bg-primary mt-6" />
        </div>

        {}
        <div className="relative w-full max-w-5xl mx-auto mb-8 group">
          {}
          <div className="absolute -inset-1 border border-primary/20 bg-background/50 backdrop-blur-sm -z-10" />
          <div className="absolute -inset-2 border border-primary/5 -z-20" />
          
          <div className="relative border border-primary/40 bg-black shadow-2xl shadow-primary/10 overflow-hidden">
            <AspectRatio ratio={16 / 9}>
              {}
              <iframe key={activeItem.id} src="https://www.youtube.com/embed/37vC-cS8dYQ?autoplay=0&controls=1&modestbranding=1" title={activeItem.title} className={`w-full h-full transition-opacity duration-500 ease-in-out ${isTransitioning ? "opacity-0" : "opacity-100"}`} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />

              {}
              <div className="absolute inset-0 pointer-events-none" />
              <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(transparent_50%,rgba(0,255,255,0.05)_50%)] bg-[length:100%_4px] mix-blend-overlay opacity-40" />

              {}
              <div className="absolute bottom-0 left-0 w-full p-8 bg-gradient-to-t from-background/95 via-background/60 to-transparent pointer-events-none">
                <div className="flex items-center gap-4 mt-3 text-sm text-primary/70 font-mono">
                  <span className="flex items-center gap-2 border border-primary/30 px-2 py-0.5 bg-primary/5">
                    <span className="size-2 rounded-lg bg-primary animate-pulse" />
                    DIRECTOR&apos;S CUT
                  </span>
                  <span className="tracking-tighter">{activeItem.duration}</span>
                </div>
              </div>
            </AspectRatio>
          </div>
        </div>

        {}
        <div className="max-w-5xl mx-auto px-12 md:px-16 relative">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {showcaseItems.map((item, index) => {
              const isActive = index === activeIndex;
              return <CarouselItem key={item.id} data-index={index} className="pl-4 basis-1/2 md:basis-1/3 lg:basis-1/4">
                    <button onClick={() => handleThumbnailClick(index)} className={`relative w-full aspect-video overflow-hidden transition-all duration-500 group ${isActive ? "border border-primary shadow-[0_0_20px_rgba(0,255,255,0.4)] scale-[1.05]" : "border border-border/20 hover:border-primary/50 hover:scale-[1.02] opacity-50 hover:opacity-100 grayscale hover:grayscale-0"}`} aria-label={`Select video: ${item.title}`} aria-current={isActive ? "true" : "false"}>
                      <img src={item.thumbnail} alt={`Thumbnail for ${item.title}`} className="w-full h-full object-cover" />
                      
                      {}
                      <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(transparent_50%,rgba(0,0,0,0.5)_50%)] bg-[length:100%_4px]" />
                      
                      {}
                      {isActive && <div className="absolute top-0 left-0 w-full h-0.5 bg-primary" />}
                    </button>
                  </CarouselItem>;
            })}
            </CarouselContent>
            <CarouselPrevious className="border-primary/30 bg-background/90 text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all -left-4 md:-left-12" />
            <CarouselNext className="border-primary/30 bg-background/90 text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all -right-4 md:-right-12" />
          </Carousel>
        </div>
      </div>
    </section>;
}